import React, { Fragment } from 'react'
import NavBar from '../../../components/NavBar'
import AddCMSForm from './AddCms'

function AddCMS (props) {
  return (
    <Fragment>
      <NavBar {...props}/>
      <AddCMSForm
      {...props}
      />
    </Fragment>
  )
}
export default AddCMS
